<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="订单编号" prop="orderNo">
                        <el-input style="width: 232px" v-model="searchForm.orderNo" placeholder="请输入订单编号"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="下单用户" prop="userInfo">
                        <el-input style="width: 232px" v-model="searchForm.username" placeholder="请输入下单用户"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="业绩类型" prop="brandId">
                        <el-select v-model="searchForm.type" placeholder="请选择业绩类型" style="width: 232px" filterable
                            clearable>
                            <el-option label="订单业绩" value="1"></el-option>
                            <el-option label="会员业绩" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单时间" prop="lastActiveTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" :loading="exporting" icon="el-icon-upload2" @click="exportFn">导出</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
    },
    data() {
        return {
            isS: false,
            dataList: {
                list: [
                    { title: '财务管理', path: '', type: '0' },
                    { title: '员工业绩表', path: '/financeManagement/performanceList', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '业绩明细', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                employeeId: '',
                username: '', // 	
                orderNo: '', // 	
                lastActiveTimeStart: '',
                lastActiveTimeEnd: '',
                pageNo: 1,
                pageSize: 10,
                type: ''
            },
            value1: [],
            value2: [],
            stars: [
                {
                    id: 1,
                    name: '一星'
                },
                {
                    id: 2,
                    name: '二星'
                },
                {
                    id: 3,
                    name: '三星'
                },
                {
                    id: 4,
                    name: '四星'
                },
                {
                    id: 5,
                    name: '五星'
                },
            ],
            columns: [
                { type: 'selection', minWidth: '80' },
                {
                    label: '下单用户', prop: 'username', minWidth: '200',
                    renderHeader: (h, scope) => {
                        return (
                            <div style="text-align:left">下单用户</div>
                        )
                    },
                    render: (h, scope) => {
                        let img = scope.row.avatarUrl ? scope.row.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')
                        return (
                            <div style="display:flex">
                                {/* <div>
                                    <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
                                </div> */}
                                <div style="margin-left:8px">
                                    {/* <div style="text-align:left">{scope.row.id || '--'}</div> */}
                                    <div style="text-align:left">{scope.row.username}</div>
                                    <div style="text-align:left">{scope.row.phone || '--'}</div>
                                </div>

                            </div>
                        )
                    }
                },
                {
                    label: '订单编号', prop: 'orderNo', minWidth: '200',
                    renderHeader: (h, scope) => {
                        return (
                            <div style="text-align:left">订单编号</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div style="text-align:left">{scope.row.orderNo || '--'}</div>
                        )
                    }
                },
                {
                    label: '业绩类型', prop: 'typeLabel', minWidth: '200',
                },
                {
                    label: '订单商品', prop: 'goodsName', minWidth: '220',
                    renderHeader: (h, scope) => {
                        return (
                            <div style="text-align:left">订单商品</div>
                        )
                    },
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.goodsInfoList) {
                            v = <div>
                                {
                                    scope.row.goodsInfoList.map(item => {
                                        return (
                                            <p style="display:flex;"><p style="text-align:left">{item.name}-{item.sku + '*' + item.num}</p></p>
                                        )
                                    })
                                }
                            </div>
                        } else if (scope.row.typeLabel == '会员业绩') {
                            v = scope.row.memberName
                        } else {
                            v = '--'
                        }
                        return (
                            <div style="text-align:left">{v}</div>
                            // <div>
                            //     {
                            //         scope.row.goodsInfoList.map(item => {
                            //             return (
                            //                 <p style="display:flex;"><p style="text-align:left">{item.name}-{item.sku + '*' + item.num}</p></p>
                            //             )
                            //         })
                            //     }
                            // </div>
                        )
                    }
                },
                {
                    label: '订单时间', prop: 'orderTime', minWidth: '200',
                    renderHeader: (h, scope) => {
                        return (
                            <div style="text-align:left">订单时间</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div style="text-align:left">{scope.row.orderTime || '--'}</div>
                        )
                    }
                },
                {
                    label: '支付金额', prop: 'payAmount', minWidth: '200',
                },
            ],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            exporting: false,
            isName: '',
            cId: '',
            showFlag: ''
        }
    },
    // created() {
    //     this.getPageList()
    // },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addComment') {
            next(vm => {
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getPageList();
            });
        }
    },
    methods: {
        exportFn() {
            this.exporting = true;
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.lastActiveTimeStart = this.value1[0];
                this.searchForm.lastActiveTimeEnd = this.value1[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.searchForm.employeeId = this.$route.query.employeeId
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/admin/outstandingExportDetailList', this.searchForm)
                .then(res => {
                    console.log(res)
                    this.exporting = false;
                    if (res.code == 0) {
                        this.downloadlink(res.data)
                    }
                })
        },
        add(id) {
            this.$router.push({
                name: 'addComment',
                query: {
                    id: id
                }
            })
        },
        updateStatus() {
            let data = {
                id: this.cId,
                showFlag: this.showFlag
            }
            this.axios.post('/psGoodsEvaluation/updateShowFlag', data).then(res => {
                if (res.code == 0) {
                    this.$message.success('更改成功')
                    this.isS = false
                    this.getPageList()
                }
            })
        },
        isShow(row) {
            this.isS = true
            this.isName = row.statusL
            this.cId = row.id
            console.log(row.showFlag)
            this.showFlag = !row.showFlag
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.value2 = []
                this.searchForm.employeeId = this.$route.query.employeeId
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
                this.searchForm.username = ''
                this.searchForm.orderNo = ''
                this.searchForm.employeeId = ''
                this.searchForm.type = ''
            }
            this.getPageList()
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.lastActiveTimeStart = this.value1[0];
                this.searchForm.lastActiveTimeEnd = this.value1[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.searchForm.employeeId = this.$route.query.employeeId
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/admin/outstandingInfo', this.searchForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.list.forEach(item => {
                            if (item.type == 1) {
                                item.typeLabel = '订单业绩'
                            } else {
                                item.typeLabel = '会员业绩'
                            }
                            item.payAmount = item.payAmount.toFixed(2)
                            if (item.goodsInfo) {
                                let goodsInfoList = []
                                item.goodsInfo.forEach(itm => {

                                    for (let i = 0; i < itm.goodsSkuNameList.length; i++) {
                                        // for (let j = 0; j < itm.skuNumList.length; j++) {
                                        //     let obj = {
                                        //         name: itm.goodsName,
                                        //         sku: itm.goodsSkuNameList[i],
                                        //         num: itm.skuNumList[j]
                                        //     }
                                        //     goodsInfoList.push(obj)
                                        // }
                                        let obj = {
                                            name: itm.goodsName,
                                            sku: itm.goodsSkuNameList[i],
                                            num: itm.skuNumList[i]
                                        }
                                        goodsInfoList.push(obj)
                                    }
                                    Object.assign(item, { goodsInfoList: goodsInfoList })
                                })
                                console.log(item.goodsInfoList)
                            }

                        })
                        this.list = res.data.list;
                        this.page.totalNum = res.data.totalNum;
                    }
                })
        },
        onMultipleSelection(e) { },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        todetail(id) {
            this.$router.push({
                name: 'lookComment',
                query: {
                    id: id
                }
            })
        }
    }
}
</script>
  
<style scoped lang="scss">
/deep/ .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);

    .el-dialog__body {
        padding: 30px 25px;
        height: 800px;
        flex: 1;
        overflow: auto;
    }
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 37px;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  